import { gql } from 'graphql-request';
import { baseApi } from './baseApi';

export const resourceTypesApi = baseApi.injectEndpoints({
  endpoints: (builder: any) => ({
    // queries
    getResourceTypes: builder.query({
      query: ({ visible = true }: { visible: Boolean }) => ({
        body: gql`
          query ResourceTypes($visible: Boolean) {
            findResourceTypes(visible: $visible) {
              code
              created_at
              id
              name
              updated_at
            }
          }
        `,
        variables: {
          visible,
        },
      }),
      transformResponse: (res: any) => res.findResourceTypes,
    }),
  }),
  overrideExisting: false,
});

export const { useGetResourceTypesQuery, useLazyGetResourceTypesQuery } = resourceTypesApi;
